import React, { useState } from 'react';
import { Alert, Card, Spinner, Table } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faExclamationCircle, faTimesCircle, faBarcode } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import ProcessoService from "../../../../services/ProcessoService";
import "./financeiro.scss";

export default function Financeiro({ financeiro, idProcesso }) {
    const [loadingBoletoId, setLoadingBoletoId] = useState(null);

    function colocaIcon(status){
        if(status === 'quitada'){
            return(
                <FontAwesomeIcon
                    title={status}
                    icon={faCheckCircle}
                    color="green"
                />
            )
        }else if(status === 'avencer'){
            return (
                <FontAwesomeIcon
                    title={status}
                    icon={faExclamationCircle}
                    color="orange"
                />
            )
        }else{
            return (
                <FontAwesomeIcon
                    icon={faTimesCircle}
                    color="red"
                    title={status}
                />
            )
        }
    }

    function handleBuscaBoleto(parcela) {
        if (!idProcesso || !parcela?.id) {
            Swal.fire({
                titleText: "Boleto não disponível, entre em contato conosco.",
                text: "",
                icon: "warning",
            });
            return;
        }

        setLoadingBoletoId(parcela.id);

        ProcessoService.buscarBoleto(idProcesso, parcela.id)
            .then((res) => {
                const retorno = res.data;
                if (retorno?.uri) {
                    Swal.fire({
                        titleText: "2ª via de boleto",
                        text: "Seu boleto está disponível para download",
                        icon: "info",
                        showCloseButton: false,
                        showCancelButton: true,
                        focusConfirm: false,
                        confirmButtonText: "Baixar boleto",
                        cancelButtonText: "Cancelar",
                        customClass: {
                            confirmButton: "btn btn-success mr-3",
                            cancelButton: "btn btn-secondary mr-3",
                        },
                        buttonsStyling: false,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            window.open(retorno.uri, "_blank");
                        }
                    });
                } else {
                    Swal.fire({
                        titleText: "Boleto não disponível, entre em contato conosco.",
                        text: "",
                        icon: "warning",
                    });
                }
            })
            .catch(() => {
                Swal.fire({
                    titleText: "Ocorreu um erro ao buscar o boleto.",
                    text: "Tente novamente ou entre em contato conosco.",
                    icon: "error",
                });
            })
            .finally(() => {
                setLoadingBoletoId(null);
            });
    }

    return financeiro?.controle_financeiro?.mensagem && 
        <Alert>{`${financeiro.controle_financeiro.mensagem} ${financeiro.controle_financeiro.motivo && `Motivo: ${financeiro.controle_financeiro.motivo}` || ''}`}</Alert> || 
        <>
            <Card.Body className="cardTabela" >
                <div className="conteudoFianceiro">
                    <Table className="tebelaFinanceiro" striped bordered hover size="sm">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Tipo da Parcela</th>
                                <th>Vencimento</th>
                                <th>Valor(R$)</th>
                                <th>2ª Via</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {financeiro.parcelas ? financeiro.parcelas.map((parcela, index) => {
                                const carregandoEstaLinha = loadingBoletoId === parcela.id;
                                return (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{parcela.tipo}</td>
                                        <td>{parcela.vencimento}</td>
                                        <td>{parcela.valor}</td>
                                        <td align="center">
                                            {carregandoEstaLinha ? (
                                                <Spinner animation="border" variant="dark" size="sm" />
                                            ) : (
                                                <FontAwesomeIcon
                                                    title="Emitir 2ª via do boleto"
                                                    icon={faBarcode}
                                                    color="#444"
                                                    style={{ cursor: "pointer", fontSize: 18 }}
                                                    onClick={() => handleBuscaBoleto(parcela)}
                                                />
                                            )}
                                        </td>
                                        <td>{colocaIcon(parcela.status)}</td>
                                    </tr>
                                )
                            }) : <></>}
                        </tbody>
                    </Table>
                </div>
            </Card.Body>
        </>
}
